import {
  EDocumentManagementStatus,
  ESignatureSettingsRequiredBy,
  TFormBuilderEntryCamel,
} from '@/types';

/**
 * Given a form builder entry, returns the current status of the document management.
 * The status is determined by the signature settings and the signatures that have been
 * completed.
 * @param entry - The form builder entry.
 * @returns The current status of the document management.
 */
export const getDocumentManagementStatus = (
  entry: TFormBuilderEntryCamel,
): EDocumentManagementStatus => {
  const { requiredBy } = entry.data.signatureSettings;

  // always entry.userInstitutionRoleId = patient role id. If BE change logic, use getUserByUserInstitutionRoleId
  const isPatientSignatureComplete = entry.signatures?.some(
    (s) => s.userInstitutionRoleId === entry.userInstitutionRoleId,
  );

  const isProviderToSign = entry.signatures?.some(
    (s) => s.userInstitutionRoleId !== entry.userInstitutionRoleId,
  );
  // if need provider signature + have provider signature or don't need provider signature  = completed
  const isProviderSignatureComplete =
    requiredBy === ESignatureSettingsRequiredBy.PATIENT_AND_PROVIDER ||
    requiredBy === ESignatureSettingsRequiredBy.PROVIDER
      ? isProviderToSign
      : true;

  if (entry.formTemplate?.userType === 'provider' && entry.meta?.isShared) {
    return EDocumentManagementStatus.SHARED;
  }

  if (
    isProviderSignatureComplete &&
    (isPatientSignatureComplete || entry.formTemplate?.userType === 'provider')
  )
    return EDocumentManagementStatus.COMPLETED;

  if (isPatientSignatureComplete)
    return EDocumentManagementStatus.PROVIDER_TO_SIGN;

  return EDocumentManagementStatus.NOT_COMPLETED;
};
